ike-portal-logo {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  svg, img {
    width: auto;
    .MD & {
      width: auto !important;
      height: 30px !important;
    }

    &.ik-logo {
      width: 229px;
      height: 32px;
    }

    &:not(.ik-logo) {
      height: 50px;
    }
  }
}
